import { useEffect } from "react";

/**
 * A custom hook that triggers a confirmation dialog when the user attempts to leave the page.
 * @param type - Optional type string used to identify the item to be removed from localStorage.
 */
export const useBeforeUnload = (type: string | undefined = undefined) => {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent): void => {
      // Remove the item from localStorage if type is provided
      if (type) {
        localStorage.removeItem(type);
      }

      // Prevent the default action of the event
      e.preventDefault();
      // Set the returnValue of the event to display the message
      e.returnValue = "Apakah anda yakin?"; // Custom message
    };

    // Attach the beforeunload event listener
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup function to remove the listener
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [type]); // Re-run if the type changes
};
